import React from 'react';

// Inline SVG icon set ported verbatim from the approved landing prototype
// (same line-art look). Stroke inherits `currentColor` so each usage colors it
// via CSS. Attributes are camelCased for JSX.

const Svg = ({ sw = 1.8, children, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={sw}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...rest}
  >
    {children}
  </svg>
);

export const Check = (p) => (
  <Svg sw={3} {...p}>
    <path d="M20 6 9 17l-5-5" />
  </Svg>
);
export const Chevron = (p) => (
  <Svg sw={2.5} {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

// hero feature row + trust + cards
export const Members = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
    <path d="M16 5.3a3.2 3.2 0 0 1 0 5.9" />
    <path d="M17.5 15.6a5.5 5.5 0 0 1 3 4.4" />
  </Svg>
);
export const Employees = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="8" r="3.6" />
    <path d="M5 20a7 7 0 0 1 14 0" />
  </Svg>
);
export const Reporting = (p) => (
  <Svg {...p}>
    <polyline points="3 17 9 11 13 15 21 7" />
    <polyline points="15 7 21 7 21 13" />
  </Svg>
);
export const Payouts = (p) => (
  <Svg {...p}>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <path d="M3 10h18" />
  </Svg>
);
export const ShieldPlain = (p) => (
  <Svg {...p}>
    <path d="M12 3l7 3v5c0 4.6-3 7.2-7 8-4-.8-7-3.4-7-8V6z" />
  </Svg>
);
export const LocationPin = (p) => (
  <Svg {...p}>
    <path d="M12 21s7-5.6 7-11a7 7 0 0 0-14 0c0 5.4 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.5" />
  </Svg>
);
export const Analytics = (p) => (
  <Svg {...p}>
    <path d="M4 20V4" />
    <path d="M4 20h16" />
    <rect x="7" y="11" width="3" height="6" />
    <rect x="13" y="7" width="3" height="10" />
  </Svg>
);
export const Permissions = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="9" r="3" />
    <path d="M3.5 19a5.5 5.5 0 0 1 9.2-2.3" />
    <path d="m14 14 2 2 4-4" />
  </Svg>
);
export const Monitoring = (p) => (
  <Svg {...p}>
    <path d="M3 12h4l3 8 4-16 3 8h4" />
  </Svg>
);
export const Headset = (p) => (
  <Svg {...p}>
    <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
    <rect x="2" y="14" width="5" height="7" rx="1.5" />
    <rect x="17" y="14" width="5" height="7" rx="1.5" />
    <path d="M20 19v1a3 3 0 0 1-3 3h-3" />
  </Svg>
);

// "why" benefit cards
export const Phone = (p) => (
  <Svg sw={1.9} {...p}>
    <rect x="5" y="2" width="14" height="20" rx="2.5" />
    <path d="M11 18h2" />
  </Svg>
);
export const ShieldCheck = (p) => (
  <Svg sw={1.9} {...p}>
    <path d="M12 3l7 3v5c0 4.6-3 7.2-7 8-4-.8-7-3.4-7-8V6z" />
    <path d="M9 12l2 2 4-4" />
  </Svg>
);
export const Target = (p) => (
  <Svg sw={1.9} {...p}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="12" cy="12" r="0.6" fill="currentColor" />
  </Svg>
);

// feature category headers
export const Home = (p) => (
  <Svg {...p}>
    <path d="M3 11l9-8 9 8" />
    <path d="M5 10v10h14V10" />
  </Svg>
);
export const ListGrid = (p) => (
  <Svg {...p}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M7 8h10M7 12h10M7 16h6" />
  </Svg>
);
export const CardIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <path d="M3 10h18" />
  </Svg>
);

// new-location setup items
export const Desktop = (p) => (
  <Svg {...p}>
    <rect x="4" y="3" width="9" height="14" rx="1" />
    <path d="M16 7h4v10h-4M8 20h4M10 17v3" />
  </Svg>
);
export const Monitor = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="18" height="11" rx="1" />
    <path d="M8 20h8M12 15v5" />
  </Svg>
);
export const Keyboard = (p) => (
  <Svg {...p}>
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10" />
  </Svg>
);
export const Camera = (p) => (
  <Svg {...p}>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);
export const RfidCard = (p) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 9h18" />
  </Svg>
);
export const RfidReader = (p) => (
  <Svg {...p}>
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M4 12h16" />
  </Svg>
);
export const Tablet = (p) => (
  <Svg {...p}>
    <rect x="6" y="2" width="12" height="20" rx="2" />
    <path d="M11 18h2" />
  </Svg>
);
